<template>
  <b-modal
    data-cy="LinkDeviceModal"
    content-class="LinkModal"
    id="link-device-modal"
    ref="modal"
    centered
    size="xl"
    hideHeaderClose
    okTitle="Link"
    :okDisabled="!selectedDevices.length"
    @show="modalShown"
    @hidden="resetModal"
    @ok="handleOk"
  >
    <template #modal-title>
      Linking device to <code>{{ assetId }}</code>
    </template>
    <b-form-checkbox-group v-model="selectedDevices">
      <Table
        class="p-0 text-left"
        :items="items"
        :fields="fields"
        :filterable="true"
        :selectable="true"
        :current-page="currentPage"
        :per-page="perPage"
        :table-options="{ stickyHeader: '400px' }"
        :total-rows="totalRows"
        @sort-changed="onSortChanged"
        @filtered="onFilterChanged"
        @page-changed="onPageChanged"
        @per-page-changed="onPerPageChanged"
      >
        <template v-slot:cell(actions)="data">
          <div class="text-center">
            <b-form-checkbox :value="data.item.deviceId" />
          </div>
        </template>
        <template v-slot:cell(measureTypes)="data">
          <div v-if="data.item.measureTypes.length">
            <b-badge
              v-for="measureType of data.item.measureTypes"
              class="mr-1"
              :key="measureType"
              >{{ measureType }}</b-badge
            >
          </div>
          <div v-else>N/A</div>
        </template>
        <template #empty>
          <h4 class="text-secondary text-center mt-1">
            No device found to link to current asset.
          </h4>
        </template>
      </Table>
    </b-form-checkbox-group>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    assetId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      items: [],
      selectedDevices: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: '',
      sort: null
    };
  },
  computed: {
    ...mapGetters('tenants', ['selectedTenant']),
    tenantId() {
      return _.get(this.selectedTenant, '_id', '');
    },
    fields() {
      return [
        {
          key: 'actions',
          label: 'Select',
          sortable: false
        },
        {
          key: 'deviceId',
          label: 'Device Id',
          sortable: true
        },
        {
          key: 'reference',
          label: 'Reference',
          sortable: true
        },
        {
          key: 'model',
          label: 'Model',
          sortable: true
        },
        {
          key: 'measureTypes',
          label: 'Measure Types',
          sortable: true
        }
      ];
    }
  },
  mounted() {
    this.fetchItems();
  },
  methods: {
    modalShown() {
      this.resetModal();
      this.fetchItems();
    },
    selectDevice(v, deviceId) {
      if (v && !this.selectedDevices.includes(deviceId)) {
        this.selectedDevices.push(deviceId);
      } else if (!v && this.selectedDevices.includes(deviceId)) {
        this.selectedDevices = this.selectedDevices.filter(d => d !== deviceId);
      }
    },
    onPageChanged(page) {
      this.currentPage = page;
      this.fetchItems();
    },
    onPerPageChanged(value) {
      this.perPage = value;
      this.currentPage = 1;
      this.fetchItems();
    },
    onFilterChanged(receivedFilter) {
      this.filter = receivedFilter;
      this.fetchItems();
    },
    onSortChanged(data) {
      this.sort = [
        {
          [data.sortBy]: {
            order: data.sortDesc ? 'desc' : 'asc'
          }
        }
      ];
      this.fetchItems();
    },
    async fetchItems() {
      let query = {
        bool: {
          should: [
            {
              bool: {
                must_not: [
                  {
                    exists: {
                      field: 'assetId'
                    }
                  }
                ]
              }
            }
          ]
        }
      };
      if (this.filter.length) {
        query.bool.should[0].bool.must = [
          {
            multi_match: {
              query: this.filter,
              type: 'phrase_prefix',
              fields: ['model.text', 'reference.text']
            }
          }
        ];
        query.bool.should.push({
          match: {
            _id: this.filter
          }
        });
      }
      if (this.sort) {
        query.sort = sort;
      }
      try {
        const result = await this.$kuzzle.query({
          index: this.tenantId,
          controller: 'device-manager/device',
          action: 'search',
          body: {
            query
          },
          from: (this.currentPage - 1) * this.perPage,
          size: this.perPage
        });
        this.items = result.result.hits.map(h => {
          return {
            deviceId: h._id,
            reference: h._source.reference,
            model: h._source.model,
            measureTypes: Object.keys(h._source.measures)
          };
        });
        this.totalRows = result.result.total;
      } catch (error) {
        this.$log.error(error);
        this.$bvToast.toast(error.message, {
          title: 'Something went wrong while fetching devices',
          noAutoHide: true,
          dismissable: true,
          variant: 'danger',
          toaster: 'b-toaster-bottom-right'
        });
      }
    },
    resetModal() {
      this.selectedDevices = [];
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$emit(
        'confirmLinkDevice',
        this.selectedDevices,
        'link-device-modal'
      );
    }
  }
};
</script>
